import { invoiceAmounts } from '../../utils/invoiceAmounts';
import { formatRupiah } from '../../utils/printHelper';
import StatusBadge from '../StatusBadge';
import { InvoiceAmountSummary } from '../invoice/InvoiceAmountSummary';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

export function InvoiceProsesDetailDialog({ selectedInvoice, setShowInvoiceDetail, showInvoiceDetail }) {
  return (
    <Dialog open={showInvoiceDetail} onOpenChange={setShowInvoiceDetail}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Detail Invoice Proses Bayar</DialogTitle>
          <p className="text-sm text-slate-600">Informasi lengkap invoice</p>
        </DialogHeader>
        {selectedInvoice && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-slate-600">Invoice Number</p>
                <p className="font-mono font-semibold">{selectedInvoice.invoice_number}</p>
              </div>
              <div>
                <p className="text-sm text-slate-600">Tanggal Invoice</p>
                <p className="font-semibold">{new Date(selectedInvoice.invoice_date).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
              </div>
              <div>
                <p className="text-sm text-slate-600">Supplier</p>
                <p className="font-semibold">{selectedInvoice.supplier_name}</p>
              </div>
              <div>
                <p className="text-sm text-slate-600">Perusahaan</p>
                <p className="font-semibold">{selectedInvoice.company_name || '-'}</p>
              </div>
              <div>
                <p className="text-sm text-slate-600">Status</p>
                <StatusBadge status={selectedInvoice.status} />
              </div>
              <div>
                <p className="text-sm text-slate-600">Nilai Dibayarkan</p>
                <p className="font-mono font-semibold text-lg text-emerald-700">Rp {formatRupiah(invoiceAmounts(selectedInvoice).nilaiDibayarkan)}</p>
              </div>
            </div>

            {/* Same breakdown, same order as the printed voucher */}
            <InvoiceAmountSummary
              invoice={selectedInvoice}
              className="bg-emerald-50 border-emerald-200"
              title="Rincian Nominal"
            />

            {selectedInvoice.po_number && (
              <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                <p className="text-sm font-semibold text-blue-700">Dari PO</p>
                <p className="font-mono">{selectedInvoice.po_number}</p>
              </div>
            )}

            {selectedInvoice.submitted_to_payment_at && (
              <div className="bg-indigo-50 p-4 rounded-lg border border-indigo-200">
                <p className="text-sm font-semibold text-indigo-700">Siap Proses</p>
                <p className="text-sm">
                  {new Date(selectedInvoice.submitted_to_payment_at).toLocaleDateString('id-ID', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })} - {new Date(selectedInvoice.submitted_to_payment_at).toLocaleTimeString('id-ID')}
                </p>
                <p className="text-sm text-slate-600">oleh {selectedInvoice.submitted_to_payment_by_name}</p>
              </div>
            )}

            {/* Items Table */}
            {selectedInvoice.items && selectedInvoice.items.length > 0 && (
              <div>
                <p className="text-sm font-semibold text-slate-700 mb-2">Items</p>
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-slate-100">
                        <th className="px-3 py-2 text-left">Item</th>
                        <th className="px-3 py-2 text-right">Qty</th>
                        <th className="px-3 py-2 text-right">Harga</th>
                        <th className="px-3 py-2 text-right">Subtotal</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedInvoice.items.map((item, idx) => (
                        <tr key={idx} className="border-b">
                          <td className="px-3 py-2">{item.name}</td>
                          <td className="px-3 py-2 text-right">{item.quantity} {item.satuan}</td>
                          <td className="px-3 py-2 text-right font-mono">Rp {formatRupiah(item.unit_price || 0)}</td>
                          <td className="px-3 py-2 text-right font-mono">Rp {formatRupiah((item.quantity || 0) * (item.unit_price || 0))}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
